import { apiFetch } from "./api";

export function getLatestVersion(platform) {
  return apiFetch(`/mobileapp/version/latest?platform=${platform}`);
}

export function createVersion({ platform, version, min_supported, notes }) {
  return apiFetch("/mobileapp/version", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ platform, version, min_supported, notes }),
  });
}

export function getRemoteConfig(platform) {
  return apiFetch(`/mobileapp/config?platform=${platform}`);
}

export function putRemoteConfig(platform, config) {
  return apiFetch("/mobileapp/config", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ platform, config }),
  });
}
